import { useModal } from 'mui-modal-provider';
import { useQuery } from '@apollo/client';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';

import { OrderCreateButton as OrderCreateButtonView } from './order-create-button';
import { AskLoginModal } from '../../../../common/ask-login-modal';
import { IOrderCreateButtonProps } from './order-create-button.models';
import { GET_IS_USER_LOGGED_IN } from '../../../../../graphql/user/queries';
import { InternalLinks } from '../../../../../constants';
import { setRedirectUrl } from '../../../../../utils/redirect/redirect';

export const OrderCreateButton = ({
  isFitted,
  onClick,
  onBeforeAuthCheck,
  to,
  text,
  style,
}: IOrderCreateButtonProps): JSX.Element => {
  const { data: { user: { isLoggedIn } } } = useQuery(GET_IS_USER_LOGGED_IN);
  const { showModal } = useModal();
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigateToRegistration = useCallback(() => {
    setRedirectUrl(location.pathname);
    navigate(InternalLinks.registration);
  }, [navigate, location.pathname]);

  const handleNavigateToLogin = useCallback(() => {
    setRedirectUrl(location.pathname);
    navigate(InternalLinks.login);
  }, [navigate, location.pathname]);

  const handleButtonClick = () => {
    if (!isLoggedIn) {
      onBeforeAuthCheck?.();
      showModal(AskLoginModal, {
        onNavigateToRegistration: handleNavigateToRegistration,
        onNavigateToLogin: handleNavigateToLogin,
      });
      return;
    }

    onClick?.();
  };

  return (
    <OrderCreateButtonView
      handleClick={handleButtonClick}
      isFitted={isFitted}
      onClick={onClick}
      to={to}
      text={text}
      style={style}
    />
  );
};
